import { type FC } from 'react'
import { useBlackDiamondWPContactSync } from '../IntegrationSpecificSettings/BlackDiamondWP/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const BlackDiamondWPCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useBlackDiamondWPContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: false,
    isSyncDisabled: false,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
